// extracted by mini-css-extract-plugin
module.exports = {"scanButton":"EquipmentMainPage_scanButton__2-PAk","scanButtonContainer":"EquipmentMainPage_scanButtonContainer__UoCd6","iconSpace":"EquipmentMainPage_iconSpace__1H3Ms"};